import { useCallback } from "react"
import { batch } from "@preact/signals-react"
import { getSubmit } from "@ui-seeker/utils"
import { useToast } from "@hooks"
import { BACKEND_APIS } from "@constants"
import {
	autoEuropeNotificationsListData,
	autoEuropeNotificationsIsLoading,
	autoEuropeCheckersData,
	autoEuropeCheckersIsLoading,
} from "Pages/AutoEuropeTool/Notifications/@signals"

const NOTIFICATIONS_API = `${BACKEND_APIS.AUTOEUROPE_PRICING_TOOL}/notifications`
const LAST_CHECKERS_API = `${BACKEND_APIS.AUTOEUROPE_PRICING_TOOL}/last-checkers`

export default function useAutoEuropeNotificationsTable() {
	const { showToast } = useToast()

	// Loads the nested selector source (pricing tool > reports > executions > offices).
	const getCheckers = useCallback(() => {
		batch(() => {
			autoEuropeCheckersIsLoading.value = true
			autoEuropeCheckersData.value = []
		})
		getSubmit(LAST_CHECKERS_API)
			.then(data => {
				batch(() => {
					autoEuropeCheckersData.value = data ?? []
					autoEuropeCheckersIsLoading.value = false
				})
			})
			.catch(() => {
				autoEuropeCheckersIsLoading.value = false
				showToast.error("Error loading checkers")
			})
	}, [])

	const getTableData = useCallback(({ idPricingTool, idReportExecution, idOfficePickup }) => {
		batch(() => {
			autoEuropeNotificationsIsLoading.value = true
			autoEuropeNotificationsListData.value = []
		})
		getSubmit(`${NOTIFICATIONS_API}/list`, { idPricingTool, idReportExecution, idOfficePickup })
			.then(data => {
				batch(() => {
					autoEuropeNotificationsListData.value = data ?? []
					autoEuropeNotificationsIsLoading.value = false
				})
			})
			.catch(() => {
				autoEuropeNotificationsIsLoading.value = false
				showToast.error("Error loading Notifications")
			})
	}, [])

	return { getCheckers, getTableData }
}